/** Product labels for Super Admin — maps stored fleet_type to platform model. */
export function fleetOwnershipLabel(fleetType: unknown): string {
  switch (String(fleetType || "")) {
    case "oelox_network":
      return "OELOX global";
    case "partner":
      return "Partner";
    case "restaurant":
      return "Client";
    default:
      return String(fleetType || "Unknown");
  }
}

/** SA-1 SoT label from tenants.client_type */
export function clientTypeLabel(type: unknown): string {
  return String(type) === "partner" ? "Partner Client" : "OELOX Client";
}

export function clientTypeStatusLabel(status: unknown): string {
  switch (String(status || "")) {
    case "needs_review":
      return "Needs review";
    case "manual_override":
      return "Manual override";
    case "confirmed":
      return "Confirmed";
    default:
      return String(status || "—");
  }
}

/** @deprecated Prefer clientTypeLabel(client_type) */
export function clientKindLabel(kind: unknown): string {
  return kind === "partner_linked" || kind === "partner" ? "Partner Client" : "OELOX Client";
}
